module.exports = __webpack_public_path__ + "static/media/esg-advisory.9a2993ed.webp";